import React, { useEffect, createElement } from 'react';
import { SectionIntro } from './components/SectionIntro';
import { SectionReasons1To3 } from './components/SectionReasons1To3';
import { SectionReasons4To6 } from './components/SectionReasons4To6';
import { SectionReasons7ToBlueprints } from './components/SectionReasons7ToBlueprints';
import { SectionReason10To11 } from './components/SectionReason10To11';
import { SectionBonuses } from './components/SectionBonuses';
import { SectionPricingAndOutro } from './components/SectionPricingAndOutro';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '782456421382407');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=782456421382407&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    // Microsoft Clarity
    const clarityScript = document.createElement('script');
    clarityScript.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "w9e23w065c");
    `;
    document.head.appendChild(clarityScript);
    // Taboola Pixel
    const taboolaScript = document.createElement('script');
    taboolaScript.innerHTML = `
      window._tfa = window._tfa || [];
      window._tfa.push({notify: 'event', name: 'page_view', id: 2020143});
      !function (t, f, a, x) {
        if (!document.getElementById(x)) {
          t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
        }
      }(document.createElement('script'),
      document.getElementsByTagName('script')[0],
      '//cdn.taboola.com/libtrc/unip/2020143/tfa.js',
      'tb_tfa_script');
    `;
    document.head.appendChild(taboolaScript);
    // Taboola CTA click tracking
    document.querySelectorAll('a[href*="clearguardnutrition.com"]').forEach(link => {
      link.addEventListener('click', () => {
        ;
        (window as any)._tfa = (window as any)._tfa || [];
        (window as any)._tfa.push({
          notify: 'event',
          name: 'ADV_CLICK_TO_SALES_PAGE',
          id: 2020143
        });
      });
    });
    // Taboola Click ID passthrough
    const urlParams = new URLSearchParams(window.location.search);
    const tblci = urlParams.get('tblci');
    if (tblci) {
      document.querySelectorAll('a[href*="clearguardnutrition.com"]').forEach(link => {
        const url = new URL((link as HTMLAnchorElement).href);
        url.searchParams.set('tblci', tblci);
        (link as HTMLAnchorElement).href = url.toString();
      });
    }
    // Google Analytics (GA4)
    ;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).gtag = function () {
      ;
      (window as any).dataLayer.push(arguments);
    };
    (window as any).gtag('js', new Date());
    (window as any).gtag('config', 'G-TEW0MBTC4Q');
    if (!document.getElementById('ga_gtag_script')) {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-TEW0MBTC4Q';
      gtagScript.id = 'ga_gtag_script';
      document.head.appendChild(gtagScript);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-[20px] md:text-[19px] leading-[1.8] text-gray-800 selection:bg-brand-green selection:text-white" data-id="element-0">
      <header className="w-full border-b border-gray-200 bg-white" data-id="element-1">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between" data-id="element-2">
          <span className="text-lg font-bold text-gray-900 tracking-tight" data-id="element-3">
            DailyOralReport
          </span>
          <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4">
            Sponsored Advertorial
          </span>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8 md:py-12" data-id="element-5">
        <article data-id="element-6">
          <SectionIntro data-id="element-7" />
          <SectionReasons1To3 data-id="element-8" />
          <SectionReasons4To6 data-id="element-9" />
          <SectionReasons7ToBlueprints data-id="element-10" />
          <SectionReason10To11 data-id="element-11" />
          <SectionBonuses data-id="element-12" />
          <SectionPricingAndOutro data-id="element-13" />
        </article>
      </main>
      <footer className="w-full bg-slate-800 text-gray-400 py-12 px-4 sm:px-6" data-id="element-14">
        <div className="max-w-3xl mx-auto text-center" data-id="element-15">
          <p className="text-base leading-relaxed mb-6" data-id="element-16">
            This is an advertorial and not an actual news article, blog, or
            consumer protection update.
          </p>
          <p className="text-base leading-relaxed mb-8" data-id="element-17">
            The statements made on this website have not been evaluated by the
            Food and Drug Administration. This product is not intended to
            diagnose, treat, cure, or prevent any disease.
          </p>
          <hr className="border-gray-600 mb-8" data-id="element-18" />
          <p className="text-sm text-gray-500" data-id="element-19">
            © 2026 ClearGuard Pro. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}